import liff from '@line/liff';

const initLiff = () => {
    return new Promise((resolve, reject) => {
        liff.init({
            liffId: process.env.REACT_APP_LIFF_ID, // Use own liffId
        }).then(() => {
            resolve(liff)
        }).catch((err) => {
            console.log(err)
            reject(err)
        })
    })
}

export default initLiff